// extracted by mini-css-extract-plugin
module.exports = {"cardChallengeSkeleton":"CardChallengeSkeleton_cardChallengeSkeleton__3fpJd","cardChallengeSkeleton_flexRow":"CardChallengeSkeleton_cardChallengeSkeleton_flexRow__11YAD"};